import React, { FC } from 'react'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import { useDeleteKnockStatusHandlers } from './hooks/useDeleteKnockStatusHandlers'

interface DeleteKnockStatusDialogProps {
  open: boolean
  onClose: () => void
  id?: string
}

export const DeleteKnockStatusDialog: FC<DeleteKnockStatusDialogProps> = ({
  open,
  onClose,
  id,
}) => {
  const { handleDelete, isDeleting } = useDeleteKnockStatusHandlers(onClose)

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ fontWeight: 600, px: 3, pt: 3, pb: 2 }}>
        Delete Knock Status
      </DialogTitle>

      <DialogContent sx={{ px: 3, pb: 2 }}>
        <Box
          sx={{
            backgroundColor: '#FDECEA',
            border: '1px solid #F5C6CB',
            borderRadius: 1,
            p: 2,
            display: 'flex',
            flexDirection: 'row',
            gap: 1.5,
            alignItems: 'flex-start',
          }}
        >
          <ErrorOutlineIcon color="error" sx={{ mt: 0.3, flexShrink: 0 }} />
          <Box>
            <Typography color="error" fontWeight={600}>
              This will permanently delete the knock status. All knock status
              history will remain as is.
            </Typography>
            <Typography color="text.primary" sx={{ mt: 0.5 }}>
              This action cannot be undone.
            </Typography>
          </Box>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => id && handleDelete(id)}
          disabled={isDeleting}
        >
          Delete Knock Status
        </Button>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  )
}
